import { render, staticRenderFns } from "./InventoryListView.vue?vue&type=template&id=2eb0a9d1&"
import script from "./InventoryListView.vue?vue&type=script&lang=js&"
export * from "./InventoryListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports